
/* injects from baggage-loader */

'use strict';

export default class SpeedDialController {
    constructor($log, Dialog) {
        'ngInject';
        this.$log = $log;
        this.Dialog = Dialog;
        

    }

    toPuzzle(){
        this.Dialog.showPuzzle('Peças do quebra-cabeça', () => {
            this.$log.log('Close Puzzle');
        });
    }

    toHelp(){
        this.Dialog.showAlert('Ajuda', this.text, () => {
            this.$log.log('Close Help');
        });
    }

    toStagesMenu(){
        this.Dialog.showStagesModal( () => {
            this.$log.log('Close Menu');
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/components/ui/speed-dial/speed-dial.controller.js